export default () => 'Practice – Conjugr8'
